import { IIconProps } from '../../types/IconProps.interface'

export const IconHamburger = ({ color = 'white' }: IIconProps) => {
  return (
    <svg className='w-full' fill='none' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.5 10H17.5M2.5 5H17.5M2.5 15H17.5'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}
